import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventChatbotAppointmentBooked } from 'entities/Chatbot'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponseEventChatbotAppointmentBooked) => void

export const useAgentAppointmentBooked = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.ChatbotAppointmentBookedTestMode, handler), [])
}
